 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML0001_COVER from '@/components/xhtml/0001_cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML0003_COPYRIGHTTITLE from '@/components/xhtml/0003_copyright-title'
 import XHTML0003_ACK from '@/components/xhtml/0003_ack'
 import XHTML0003_DED from '@/components/xhtml/0003_ded'
 import XHTML0003_PRO from '@/components/xhtml/0003_pro'
 import XHTML0003A_COPYRIGHTTITLE from '@/components/xhtml/0003a_copyright-title'
 import XHTML0004_CHAPTERTITLE1 from '@/components/xhtml/0004_chapter-title-1'
 import XHTML0005_CHAPTERTITLE2 from '@/components/xhtml/0005_chapter-title-2'
 import XHTML0006_CHAPTERTITLE3 from '@/components/xhtml/0006_chapter-title-3'
 import XHTML0007_CHAPTERTITLE4 from '@/components/xhtml/0007_chapter-title-4'
 import XHTML0008_CHAPTERTITLE5 from '@/components/xhtml/0008_chapter-title-5'
 import XHTML0009_CHAPTERTITLE6 from '@/components/xhtml/0009_chapter-title-6'
 import XHTML0010_CHAPTERTITLE7 from '@/components/xhtml/0010_chapter-title-7'
 import XHTML0011_CHAPTERTITLE8 from '@/components/xhtml/0011_chapter-title-8'
 import XHTML0012_CHAPTERTITLE9 from '@/components/xhtml/0012_chapter-title-9'
 import XHTML0012A_CHAPTERTITLE9 from '@/components/xhtml/0012a_chapter-title-9'
 import XHTML0012B_CHAPTERTITLE9 from '@/components/xhtml/0012b_chapter-title-9'
 import XHTML0012C_CHAPTERTITLE9 from '@/components/xhtml/0012c_chapter-title-9'
 import XHTML0013_CHAPTERTITLE10 from '@/components/xhtml/0013_chapter-title-10'
 import XHTML0013A_CHAPTERTITLE10 from '@/components/xhtml/0013a_chapter-title-10'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML0014_BIBLIOGRAPHYTITLE from '@/components/xhtml/0014_bibliography-title'
 import XHTML0015A_AUTHTITLE from '@/components/xhtml/0015a_auth-title'
 import XHTML0016_CREDITSTITLE from '@/components/xhtml/0016_credits-title'
 import XHTML0017_REFERENCETITLE from '@/components/xhtml/0017_reference-title'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/0001_cover",
 			"name" : "xhtml/0001_cover",
 			"component" : XHTML0001_COVER
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/0003_copyright-title",
 			"name" : "xhtml/0003_copyright-title",
 			"component" : XHTML0003_COPYRIGHTTITLE
 		},
 		{
 			"path" : "/xhtml/0003_ack",
 			"name" : "xhtml/0003_ack",
 			"component" : XHTML0003_ACK
 		},
 		{
 			"path" : "/xhtml/0003_ded",
 			"name" : "xhtml/0003_ded",
 			"component" : XHTML0003_DED
 		},
 		{
 			"path" : "/xhtml/0003_pro",
 			"name" : "xhtml/0003_pro",
 			"component" : XHTML0003_PRO
 		},
 		{
 			"path" : "/xhtml/0003a_copyright-title",
 			"name" : "xhtml/0003a_copyright-title",
 			"component" : XHTML0003A_COPYRIGHTTITLE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js